export enum Show {
    FullyUtilized = 1,
    Utilization = 2
}

export enum ProductActionType {
    Add = 1,
    Edit = 2,
    Close = 3,
    Reopen = 4
}